import React from "react";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { EdicaoList } from "components/EdicaoList";
import { AddEditionForm } from "components/AddEditionForm";

export const AddEdition: React.FC = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

    return(
        <Grid 
            container
            direction={isSmallScreen ? "column" : "row"}
            sx={{
                display: "flex",
                gap: "16px",
                justifyContent: "center",
            }}
        >
            <AddEditionForm/>
            <EdicaoList/>
        </Grid>
    );
};